import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seek-policies-terms',
  templateUrl: './policies-terms.component.html',
  styleUrls: ['./policies-terms.component.scss']
})
export class PoliciesTermsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
